<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-spin-fade" [fullScreen] = "false"><p style="color: white" > Loading... </p></ngx-spinner>
<app-navbar id="main-content-element" *ngIf="loginDisplay" ></app-navbar>
  <div class="main-content" *ngIf="loginDisplay">
    <app-modal-popup [time]="countDown" (emitEvent)="modalPopUp($event)" *ngIf="isTimeout"></app-modal-popup>


    <toast-notification></toast-notification>
    <div class="content-wrapper">
    <router-outlet *ngIf="loginDisplay"></router-outlet>
  </div>
  </div>
  <app-footer *ngIf="loginDisplay" class="mt-auto"></app-footer>
